import { cn } from '@insta-club/utilities';

function Divider({ className }: { className?: string }) {
    return <hr className={cn('h-0.5 border-t-0 bg-neutral-100', className)} />;
}

export default Divider;

